import { render, staticRenderFns } from "./commissionRule.vue?vue&type=template&id=07eb428c&"
import script from "./commissionRule.vue?vue&type=script&lang=js&"
export * from "./commissionRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07eb428c')) {
      api.createRecord('07eb428c', component.options)
    } else {
      api.reload('07eb428c', component.options)
    }
    module.hot.accept("./commissionRule.vue?vue&type=template&id=07eb428c&", function () {
      api.rerender('07eb428c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/commissionRule.vue"
export default component.exports